import { withChartLayout } from 'components/common';
import NewbornAssessment from 'components/features/chart/system-assessment/newborn-assessment/NewbornAssessment';

const NewbornAssessmentPage = withChartLayout('Newborn Assessment')(NewbornAssessment);
export default NewbornAssessmentPage;
